import React from 'react';
import { INodeItemProps } from '../interface/svgEditor';
import { UmuInput, Button } from '@umu/umu-design';

const NodeItem: React.FC<INodeItemProps> = ({ config, value, onInputChange, onButtonClick, className = '' }) => {
    const params: any = {
        expandConfig: {
            defaultValue: value,
            placeholder: config.placeholder,
        },
    };
    return (
        <div className={`svg-editor-node-group ${className}`}>
            <label className="svg-editor-node-label">{config.label}</label>
            <UmuInput {...params} onChange={(e) => onInputChange(e.value)} className="svg-editor-input" />
            <Button onClick={onButtonClick} className="svg-editor-button" type="primary">
                应用
            </Button>
        </div>
    );
};

export default NodeItem;
